(function () {
  var DEDUPE_MS = 500;
  var lastItemsAddedKey = "";
  var lastItemsAddedAt = 0;

  function getCurrency() {
    return (
      window.__OAIQ_CURRENCY__ ||
      (window.Shopify && Shopify.currency && Shopify.currency.active) ||
      "USD"
    );
  }

  function getCartUrl() {
    return (
      (window.theme && window.theme.routes && window.theme.routes.cart) ||
      "/cart.js"
    );
  }

  function fetchCart() {
    return fetch(getCartUrl(), { credentials: "same-origin" }).then(function (
      response
    ) {
      return response.json();
    });
  }

  function measure(eventName, data, options) {
    if (typeof window.oaiq !== "function") return;
    var payload = Object.assign({ type: "contents" }, data || {});
    if (options) {
      window.oaiq("measure", eventName, payload, options);
    } else {
      window.oaiq("measure", eventName, payload);
    }
  }

  function contentId(item) {
    return String(item.sku || item.variant_id || item.id || "");
  }

  function contentName(item) {
    return item.product_title || item.title || item.name || "";
  }

  function lineAmount(item) {
    return (
      item.final_line_price ||
      item.line_price ||
      item.final_price ||
      item.price ||
      0
    );
  }

  function mapCartItem(item) {
    var currency = getCurrency();
    var content = {
      id: contentId(item),
      name: contentName(item),
      content_type: "product",
      quantity: item.quantity || 1,
    };
    var amount = lineAmount(item);
    if (amount) {
      content.amount = amount;
      content.currency = currency;
    }
    return content;
  }

  function itemsAddedKey(data) {
    if (data && Array.isArray(data.items)) {
      return data.items
        .map(function (item) {
          return contentId(item) + ":" + (item.quantity || 1);
        })
        .join("|");
    }
    if (data && (data.variant_id || data.id)) {
      return contentId(data) + ":" + (data.quantity || 1);
    }
    return "";
  }

  function trackItemsAddedFromResponse(data) {
    var currency = getCurrency();
    var items = [];
    var amount = 0;

    if (data && Array.isArray(data.items)) {
      items = data.items;
      amount = data.total_price || 0;
    } else if (data && (data.variant_id || data.id)) {
      items = [data];
      amount = lineAmount(data);
    }

    if (!items.length) {
      measure("items_added", { currency: currency, contents: [] });
      return;
    }

    measure("items_added", {
      amount: amount,
      currency: currency,
      contents: items.map(mapCartItem),
    });
  }

  function trackItemsAddedOnce(data) {
    var key = itemsAddedKey(data);
    var now = Date.now();
    if (key && key === lastItemsAddedKey && now - lastItemsAddedAt < DEDUPE_MS) {
      return;
    }
    lastItemsAddedKey = key;
    lastItemsAddedAt = now;
    trackItemsAddedFromResponse(data);
  }

  function cartQuantityByVariant(cart) {
    var map = {};
    (cart.items || []).forEach(function (item) {
      map[item.variant_id] = item.quantity || 0;
    });
    return map;
  }

  function totalCartQuantity(cart) {
    return (cart.items || []).reduce(function (sum, item) {
      return sum + (item.quantity || 0);
    }, 0);
  }

  function findAddedLineItem(beforeCart, afterCart) {
    var beforeMap = cartQuantityByVariant(beforeCart);
    var addedItem = null;

    (afterCart.items || []).forEach(function (item) {
      var previousQty = beforeMap[item.variant_id] || 0;
      if (item.quantity > previousQty) {
        addedItem = Object.assign({}, item, {
          quantity: item.quantity - previousQty,
          final_line_price: item.final_price
            ? item.final_price * (item.quantity - previousQty)
            : lineAmount(item),
          line_price: item.price
            ? item.price * (item.quantity - previousQty)
            : lineAmount(item),
        });
      }
    });

    return addedItem;
  }

  function cartHasIncreased(beforeCart, afterCart) {
    return totalCartQuantity(afterCart) > totalCartQuantity(beforeCart);
  }

  function trackPageFlyCartAdd() {
    var beforeCart = null;

    fetchCart()
      .then(function (cart) {
        beforeCart = cart;
      })
      .catch(function () {
        beforeCart = { items: [] };
      })
      .then(function () {
        var attempts = 0;
        var timer = setInterval(function () {
          attempts += 1;
          if (attempts > 15) {
            clearInterval(timer);
            return;
          }

          fetchCart()
            .then(function (afterCart) {
              if (!beforeCart || !cartHasIncreased(beforeCart, afterCart)) {
                return;
              }

              clearInterval(timer);
              var addedItem = findAddedLineItem(beforeCart, afterCart);
              if (addedItem) {
                trackItemsAddedOnce(addedItem);
              }
            })
            .catch(function () {});
        }, 200);
      });
  }

  function trackCheckoutStarted() {
    fetchCart()
      .then(function (cart) {
        measure("checkout_started", {
          amount: cart.total_price || 0,
          currency: cart.currency || getCurrency(),
          contents: (cart.items || []).map(function (item) {
            return {
              id: contentId(item),
              name: contentName(item),
              content_type: "product",
              quantity: item.quantity || 1,
            };
          }),
        });
      })
      .catch(function () {
        measure("checkout_started", { currency: getCurrency(), contents: [] });
      });
  }

  function isDynamicCheckoutClick(target) {
    return !!(
      target.closest(".shopify-payment-button") ||
      target.closest(".additional-checkout-buttons")
    );
  }

  function isPageFlyAddToCartClick(target) {
    return !!target.closest('[data-pf-type="ProductATC2"]');
  }

  document.addEventListener("ajaxProduct:added", function (event) {
    if (event.detail && event.detail.product) {
      trackItemsAddedOnce(event.detail.product);
    }
  });

  document.addEventListener("oaiq:cartAdd", function (event) {
    if (event.detail) {
      trackItemsAddedOnce(event.detail);
    }
  });

  document.addEventListener(
    "submit",
    function (event) {
      var form = event.target;
      if (!form || !form.querySelector) return;
      if (form.querySelector('button.cart__checkout[name="checkout"]')) {
        trackCheckoutStarted();
      }
    },
    true
  );

  document.addEventListener(
    "click",
    function (event) {
      if (isDynamicCheckoutClick(event.target)) {
        trackCheckoutStarted();
        return;
      }

      if (isPageFlyAddToCartClick(event.target)) {
        trackPageFlyCartAdd();
      }
    },
    true
  );
})();
